import { render } from "./PaychanguBankTransferCallbackWebsite.vue?vue&type=template&id=5c406711&scoped=true"
import script from "./PaychanguBankTransferCallbackWebsite.vue?vue&type=script&lang=js"
export * from "./PaychanguBankTransferCallbackWebsite.vue?vue&type=script&lang=js"

import "./PaychanguBankTransferCallbackWebsite.vue?vue&type=style&index=0&id=5c406711&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c406711"]])

export default __exports__